<template>
    <b-tab no-body :title="$t('message.fichiersExternes')" :active="pathHas('fichiersExternes') ">
        <div id="manuscrit">
            <h3 class="text-center"> {{ $t('message.manuscritConsultations') }}</h3>
            <b-link class="ml-4" variant="primary" @click="toManuscrit" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                <i class="fas fa-plus-circle edit-icon"></i>{{ $t('message.manuscrit') }}
            </b-link>
            <b-card-body>
                <vue-good-table v-if="notEmpty(manuscritRows) && !mobileView" :columns="manuscritColumns" :rows="manuscritRows" :search-options="enabled" :pagination-options="paginationOptions" :sort-options="sort" @on-row-click="onManuscritRowClick" />
            
             <div id="table-demo" v-if="mobileView"> <!-- && !mobileView -->
                <div class="ltemp--content--box border border-1 py-2 my-2 rounded bg-white" v-for="(row, x) in manuscritRows" :key="x"  @click="onManuscritRowClickMobile(row.slug)">
                    <div class="trajet__info bg-white mt-2" > <!-- v-for="(item, index) in ligne_temps" :key="index" -->
                        <div class="trajet__info--text h-100 d-flex align-items-center justify-content-between fs-6">
                            <span class="d-flex align-items-center text-gray px-3">
                                <i class="fa fa-calendar" aria-hidden="true"></i>
                                <span class="px-1">{{row.date}}</span>
                            </span>
                            <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                            <span class="text-default text-gray px-1">{{row.etablissement}}</span>
                            <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                            <span class="text-default d-none d-md-block">{{row.practicien}}</span>
                            <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                            <span class="text-default d-none d-md-block"></span>
                            <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                            <span class="px-3">
                                <b-button class="border-0 p-0 d-flex align-items-center shadow-none bg-transparent text-primary" @click="onManuscritRowClickMobile(row.slug) "><!-- :to="{ name: 'consultation-general' , params: { file: this.$route.params.file } }" -->
                                    <span class="d-none d-md-block">Voir</span>
                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                </b-button> 
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div id="bulleteinsExamen" class="mt-5">
                <h3 class="text-center"> Bulletin d'examen </h3>

                <div class="row"> <!-- v-if="teleconsultations.data"-->
                    <!-- <h3 class="text-center mt-5"> {{ $t('message.bulleteinsExamen') }}</h3> -->
                    <div class="text-center">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Référence</th>
                                    <th>Ligne de temps</th>
                                    <th>Urgence</th>
                                    <th>Medecin</th>
                                    <th>Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr> -->
                                <tr v-for="(bulletin, index) in this.bulletins.data.data" :key="'bulletin' + index">
                                    <td>AB #{{ bulletin.id }}</td> <!-- {{ index + 1 }}-->
                                    <td>{{ bulletin.ligne_temps.description }}</td> <!-- v-html="teleconsultation.cat" -->
                                    <td>{{ bulletin.niveau_urgence_id }}</td> <!-- {{ teleconsultation.etablissements.length > 0 ? teleconsultation.etablissements[0].name : "" }}-->
                                    <td>
                                        <span v-for="(med, index) in bulletin.medecin" :key="'motif' + index">
                                            <span>{{ med.name }}</span><!-- v-for="(motif, index) in teleconsultation.motifs" :key="'motif'+index" v-html="motif.description"-->
                                        </span>
                                    </td> <!-- {{ teleconsultation.medecin.length > 0 ? teleconsultation.medecin[0].name : "" }} -->
                                    <td>
                                        {{ bulletin.created_at }}
                                    </td>
                                    <td>
                                        <b-button variant="outline-success" class="border-0" @click="printBulletin(bulletin.pdf)">
                                            <i class="fa fa-print"></i>
                                            Impriner
                                        </b-button>
                                        <!-- <button type="button" @click="printBulletin(bulletin.pdf)" class="btn btn-light"><i class="fa fa-print"></i><span>Impriner</span></button>  -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div id="bonPriseEnCharge" class="mt-5">
                <h3 class="text-center"> Bon de Prise en Charge</h3>

                <div class="row"> <!-- v-if="teleconsultations.data"-->
                    <!-- <h3 class="text-center mt-5"> {{ $t('message.bulleteinsExamen') }}</h3> -->
                    <div class="text-center">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Référence</th>
                                    <th>Ligne de temps</th>
                                    <th>Urgence</th>
                                    <th>Medecin</th>
                                    <th>Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr> -->
                                <tr v-for="(prescript_imagerie, index) in this.bons.data.data" :key="'prescript_imagerie' + index">
                                    <td>IM #{{ prescript_imagerie.id }}</td> <!-- {{ index + 1 }}-->
                                    <td>{{ prescript_imagerie.ligne_temps.description }}</td> <!-- v-html="teleconsultation.cat" -->
                                    <td>{{ prescript_imagerie.niveau_urgence_id }}</td> <!-- {{ teleconsultation.etablissements.length > 0 ? teleconsultation.etablissements[0].name : "" }}-->
                                    <td>
                                        <span v-for="(med, index) in prescript_imagerie.medecin" :key="'motif' + index">
                                            <span>{{ med.name }}</span><!-- v-for="(motif, index) in teleconsultation.motifs" :key="'motif'+index" v-html="motif.description"-->
                                        </span>
                                    </td> <!-- {{ teleconsultation.medecin.length > 0 ? teleconsultation.medecin[0].name : "" }} -->
                                    <td>
                                        {{ prescript_imagerie.created_at }}
                                    </td>
                                    <td>
                                        <b-button variant="outline-success" class="border-0" @click="printBonPriseCharge(prescript_imagerie.pdf)">
                                            <i class="fa fa-print"></i>
                                            Impriner
                                        </b-button>
                                        <!-- <button type="button" @click="printBonPriseCharge(prescript_imagerie.pdf)" class="btn btn-light"><i class="fa fa-print"></i><span>Impriner</span></button>  -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div id="prescriptionImagerie" class="mt-5">
                <h3 class="text-center"> Prescription Imagerie</h3>

                <div class="row"> <!-- v-if="teleconsultations.data"-->
                    <!-- <h3 class="text-center mt-5"> {{ $t('message.bulleteinsExamen') }}</h3> -->
                    <div class="text-center">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Référence</th>
                                    <th>Ligne de temps</th>
                                    <th>Urgence</th>
                                    <th>Médecin</th>
                                    <th>Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr> -->
                                <tr v-for="(imagerie, index) in this.prescriptionImageries.data.data" :key="'imagerie' + index">
                                    <td>BPC #{{ imagerie.id }}</td> <!-- {{ index + 1 }}-->
                                    <td>{{ imagerie.ligne_temps.description }}</td> <!-- v-html="teleconsultation.cat" -->
                                    <td>{{ imagerie.niveau_urgence_id }}</td> <!-- {{ teleconsultation.etablissements.length > 0 ? teleconsultation.etablissements[0].name : "" }}-->
                                    <td>
                                        <span v-for="(med, index) in imagerie.medecin" :key="'motif' + index">
                                            <span>{{ med.name }}</span><!-- v-for="(motif, index) in teleconsultation.motifs" :key="'motif'+index" v-html="motif.description"-->
                                        </span>
                                    </td> <!-- {{ teleconsultation.medecin.length > 0 ? teleconsultation.medecin[0].name : "" }} -->
                                    <td>
                                        {{ imagerie.created_at }}
                                    </td>
                                    <td>
                                        <b-button variant="outline-success" class="border-0" @click="printPrescription(imagerie.pdf)">
                                            <i class="fa fa-print"></i>
                                            Impriner
                                        </b-button>
                                        <!-- <button type="button" @click="printPrescription(imagerie.pdf)" class="btn btn-light"><i class="fa fa-print"></i><span>Impriner</span></button>  -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
            </b-card-body>
        </div>
    </b-tab>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import moment from "moment";
export default {
    name: "FichierExterne",
    computed: {
         ...mapGetters(["file", "bulletins", "bons", "prescriptionImageries"]),

        mMedicalFile: function () {
            return _.isUndefined(this.file) ? [] : this.file;
        },
        manuscritRows: function () {
            let self = this;
            let cArray = [];
            let consultationsInitiale = self.mMedicalFile.consultations_manuscrites;
            let consultations = _.orderBy(consultationsInitiale, ['id'], ['desc']);
            _.forEach(consultations, function (consultation) {
                let author = consultation.praticien;
                let fullName = '';
                if (!_.isNull(author)) {
                    let prenom = (author.prenom == null) ? '' : author.prenom;
                    fullName = (author.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                } else {
                    fullName = consultation.praticien_externe;
                }

                cArray.push({
                    'type': consultation.name == 'null' ? consultation.consultation_externe : consultation.name,
                    'etablissement': _.isNull(consultation.etablissement) ? '' : consultation.etablissement.name,
                    'praticien': fullName,
                    'date': consultation.date_consultation,
                    'slug': consultation.slug,
                });
            })

            return cArray;
        },
    },
    props: ['hasAdminRole', 'hasMedecinControleRole', 'hasAssistante', 'hasPraticienRole', 'file_id'],
    data() {
        return {
            mobileView:true,
            manuscritColumns: [{
                    label: this.$i18n.tc('message.institutions', 1),
                    field: 'etablissement',
                },
                {
                    label: this.$i18n.tc('message.practitioners', 1),
                    field: 'praticien',
                },
                {
                    label: this.$i18n.tc('message.types', 1),
                    field: 'type',
                },
                {
                    label: this.$i18n.t('message.consultationDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],
            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [3, 6, 10]
            },

            enabled: {
                enabled: true
            },

            sort: {
                enabled: true,
                initialSortBy: {
                    field: 'date',
                    type: 'desc'
                }
            },
            
        }
    },
    validations() {
        return {
            form: {
                responsable:{},
            }
        }
	},
    methods: {
        getBonPriseCharge(page = 1) {
            let args = {
                page: 1,
                page_size: 10,
                patient_id: localStorage.getItem('dossier_medical_slug')
            };

            this.$store.dispatch("getBonPriseCharge", { args });
        },
        getBulletins(page = 1) {
            let args = {
                page: 1,
                page_size: 10,
                patient_id: localStorage.getItem('dossier_medical_slug')
            };

            this.$store.dispatch("getBulletins", { args });
        },
        getPrescriptionImagerie(page = 1) {
            let args = {
                page: 1,
                page_size: 10,
                patient_id: localStorage.getItem('dossier_medical_slug')
            };

            this.$store.dispatch("getPrescriptionImagerie", { args });
        },
        handleView() {
            this.mobileView = window.innerWidth <= 990;
                },
        onMedecineRowClickMobile(params) {
            // console.log(params)
            this.$router.push({
                name: 'consultation-general',
                params: {
                    consultation: params
                }
            });
        },
        onManuscritRowClick(params) {
            this.$router.push({
                name: 'consultation-manuscrit',
                params: {
                    consultation: params.row.slug
                }
            });
        },
        onManuscritRowClickMobile(params) {
            this.$router.push({
                name: 'consultation-manuscrit',
                params: {
                    consultation: params
                }
            });
        },
        
        toManuscrit() {
            this.$router.push({
                name: 'add-consultation-manuscrit',
                params: {
                    file: this.file_id
                }
            })
        },
        pathHas(element) {
        let result = (this.$route.fullPath).includes(element);
            if (result) {
                if ($('#' + element).length) {
                    document.getElementById(element).scrollIntoView(top);
                }
            }

            return result;
        },
        notEmpty(item) {
            return item.length > 0;
        },
    },
     created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
    },
    mounted() {
        this.getBulletins();
        this.getBonPriseCharge();
        this.getPrescriptionImagerie();
    }
}
</script>
<style lang="">
    
</style>